import { type JSX, Show } from "solid-js";

/** The titled `.panel` shell shared by every run-output section: a heading, an
 * optional count badge, and a body that can run flush for full-bleed tables. */
export function PanelSection(props: {
  title: string;
  count?: number;
  flush?: boolean;
  children: JSX.Element;
}) {
  return (
    <section class="panel">
      <div class="panel-head">
        <span class="panel-title">{props.title}</span>
        <Show when={props.count !== undefined}>
          <span class="badge">{props.count}</span>
        </Show>
      </div>
      <div class={props.flush ? "panel-body is-flush" : "panel-body"}>
        {props.children}
      </div>
    </section>
  );
}
